/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-key */
/* eslint-disable import/named */
import "../../styles/DashboardPage.scss";
import "../../styles/DashboardPageV2.scss";
import "../../styles/Ticker.scss";
import { Button } from "reactstrap";
import { DashboardPageProps } from "./typings";
import {
  FirebaseReducer,
  FirestoreReducer,
  getFirebase,
  isLoaded
} from "react-redux-firebase";
import { Icon } from "react-icons-kit";
import { RouteComponentProps } from "react-router";
import {
  checkSquare,
  download,
  eye,
  mail,
  phone,
  plus,
  power,
  refreshCw,
  search,
  settings,
  xCircle
} from "react-icons-kit/feather";
import { compose } from "redux";
import { connect } from "react-redux";
import {
  downloadClaimDetailCsvForUser,
  getLatestClaimNotes
} from "../../actions/update-claim";
import { getNewsFeed } from "../../../src/actions/new-claim";
import CompletedClaims from "./tiles/CompletedClaims";
import Helmet from "react-helmet";
import IncomingClaims from "./tiles/IncomingClaims";
import LoadingPage from "../loading/LoadingPage";
import OutgoingClaims from "./tiles/OutgoingClaims";
import React, { Component } from "react";
import dashIncomingIcon from "../../images/svg-files/dash-incoming.svg";
import dashOutgoingIcon from "../../images/svg-files/dash-outgoing.svg";
import moment from "moment";
import newsIcon from "../../images/News.svg";

import InfoPanel from "../modals/infopanel/InfoPanel";
import NewsTicker from "../newsFeed/NewsTicker/index";
import Ticker from "../newsFeed/Ticker/index";

class DashboardPage extends Component<
  RouteComponentProps & FirebaseReducer.Reducer & DashboardPageProps,
  {
    data: any[] | null;
    latestNotes: any[];
    searchValue: string;
    searchError: string;
    downloadReportLoading: boolean;
    infoPanelOpen: boolean;
    infoPanelInitialTab: string;
  }
> {
  private static USE_NEW_V2_LAYOUT = true;

  constructor(props: any) {
    super(props);
    this.state = {
      data: null,
      latestNotes: [],
      searchValue: "",
      searchError: "",
      downloadReportLoading: false,
      infoPanelOpen: false,
      infoPanelInitialTab: "1"
    };
    this.logout = this.logout.bind(this);
    this.getNewsFeeds = this.getNewsFeeds.bind(this);
  }

  componentDidMount() {
    this.getNewsFeeds();
    this.getLatestNotes();
  }

  componentDidUpdate(prevProps: any) {
    const prevPartnerId = prevProps?.profile?.partnerId || null;
    const currentPartnerId = (this.props as any)?.profile?.partnerId || null;

    // Profile loads asynchronously; refresh notes once partnerId becomes available.
    if (prevPartnerId !== currentPartnerId && currentPartnerId) {
      this.getLatestNotes(currentPartnerId);
    }
  }

  logout() {
    this.props.firebase.logout();
  }

  getNewsFeeds = async () => {
    try {
      const response: any = await getNewsFeed();
      const rows = response?.newsFeedData?.data;
      this.setState({ data: Array.isArray(rows) ? rows : [] });
    } catch (e) {
      console.error(e);
    }
  };

  getLatestNotes = async (partnerIdOverride?: string) => {
    try {
      const partnerId =
        partnerIdOverride ||
        (this.props as any)?.profile?.partnerId ||
        undefined;
      const notes = await getLatestClaimNotes(4, partnerId);
      this.setState({ latestNotes: Array.isArray(notes) ? notes : [] });
    } catch (e) {
      console.error(e);
      this.setState({ latestNotes: [] });
    }
  };

  private toList = (claims: any): any[] => {
    if (!claims) {
      return [];
    }
    if (Array.isArray(claims)) {
      return claims;
    }
    return Object.entries(claims).map(([id, claim]: [string, any]) => ({
      ...claim,
      id
    }));
  };

  handleSearchValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      searchValue: event.target.value,
      searchError: ""
    });
  };

  handleDashboardSearch = () => {
    const searchTerm = this.state.searchValue.trim();
    const { searchChange } = this.props as any;

    if (!searchTerm) {
      if (searchChange) {
        searchChange("");
      }
      this.setState({ searchError: "" });
      return;
    }

    const normalizedSearchTerm = searchTerm.toLowerCase();
    const claimsByRoute = [
      {
        route: "/incoming",
        claims: this.toList((this.props as any).incomingClaims)
      },
      {
        route: "/outgoing",
        claims: this.toList((this.props as any).outgoingClaims)
      },
      {
        route: "/completed",
        claims: this.toList((this.props as any).completedClaims)
      }
    ];

    let matchedRoute = "";
    let matchedClaim: any = null;

    claimsByRoute.some(({ route, claims }) => {
      const claim = claims.find(
        (item: any) =>
          String(item?.insurer?.claimNumber || "")
            .trim()
            .toLowerCase() === normalizedSearchTerm ||
          String(item?.vehicle?.registrationNumber || "")
            .trim()
            .toLowerCase() === normalizedSearchTerm
      );

      if (claim) {
        matchedRoute = route;
        matchedClaim = claim;
        return true;
      }

      return false;
    });

    if (!matchedClaim || !matchedRoute) {
      if (searchChange) {
        searchChange("");
      }
      this.setState({ searchError: "No result found" });
      return;
    }

    const claimNumber = String(
      matchedClaim?.insurer?.claimNumber || searchTerm
    ).trim();

    if (searchChange) {
      searchChange(claimNumber);
    }

    this.setState({ searchError: "" }, () => {
      this.props.history.push({
        pathname: matchedRoute,
        state: {
          activeClaimId: matchedClaim?.id || null,
          claimNumber
        }
      });
    });
  };

  handleSearchKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.handleDashboardSearch();
    }
  };

  exportToCsv = (filename: string, rows: any[]): void => {
    if (!rows || !rows.length) {
      return;
    }
    const headerList = [
      "Claim Id",
      "Claim Number",
      "Origin Member",
      "Destination Member",
      "Status",
      "Cancelled by",
      "Cancelled Reason",
      "Calibration Certificate",
      "Incident Type",
      "Cause Of Loss",
      "Glass Position",
      "Created On",
      "Proof Of Payment",
      "Contact Client",
      "Book In Date",
      "Confirm Estimate",
      "Complete Fitment",
      "Vehicle Images",
      "Calibration Certificate",
      "Collected Excess",
      "Invoice",
      "Ratings Destination Created",
      "Ratings Destination Updated",
      "Rated By Destination Member",
      "Rated By Destination User",
      "Rated On Destination",
      "Rating Destination",
      "Reason Destination",
      "Rated By Origin Member Rating Member",
      "Rated By Origin Member Rating User",
      "Rated On Origin Member Rating",
      "Rating Origin Member Rating",
      "Reason Origin Member Rating"
    ];
    const separator = ",";
    const csvContent =
      "sep=,\n" +
      headerList.join(separator) +
      "\n" +
      rows
        .map((row: any) => (row === null || row === undefined ? "" : row))
        .join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  handleDownloadReport = async () => {
    if (this.state.downloadReportLoading) {
      return;
    }
    this.setState({ downloadReportLoading: true });
    try {
      const partnerId: string | undefined = (this.props as any).profile
        ?.partnerId;
      const respo = await downloadClaimDetailCsvForUser(partnerId);
      if (respo !== undefined && respo[0]) {
        this.exportToCsv("MyClaimDetails.csv", respo[0] as any[]);
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ downloadReportLoading: false });
    }
  };

  private renderNewLayout() {
    const { incomingClaims, outgoingClaims, completedClaims, loading } =
      this.props;
    const { downloadReportLoading } = this.state;
    const isAdmin = (this.props as any)?.profile?.partnerId === "Admin";

    const incomingList = this.toList(incomingClaims);
    const outgoingList = this.toList(outgoingClaims);
    const completedList = this.toList(completedClaims);
    const complaintList = this.toList((this.props as any).complaints);
    const allClaims = [...incomingList, ...outgoingList, ...completedList];

    const countStatus = (list: any[], status: string): number => {
      return list.filter(
        (claim: any) => String(claim?.status || "").toUpperCase() === status
      ).length;
    };

    const getTopMembers = (list: any[], key: "origin" | "partner") => {
      const counts: { [member: string]: number } = {};
      list.forEach((claim: any) => {
        const member = claim?.assign?.[key];
        if (member) {
          counts[member] = (counts[member] || 0) + 1;
        }
      });

      return Object.entries(counts)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 3)
        .map(([member]) => member);
    };

    const incomingCount = incomingList.length;
    const outgoingCount = outgoingList.length;
    const openComplaintsCount = complaintList.filter(
      (complaint: any) =>
        String(complaint?.status || "").toUpperCase() !== "RESOLVED"
    ).length;
    const cancelledCount = countStatus(allClaims, "CANCELLED");
    const invoicedCount = countStatus(allClaims, "INVOICED");
    const totalWithoutCancel = Math.max(
      incomingCount + outgoingCount - cancelledCount,
      0
    );
    const totalClaims = incomingCount + outgoingCount;
    const completedCount = completedList.length;

    const topClaimsSent = getTopMembers(outgoingList, "partner");
    const topClaimsReceived = getTopMembers(incomingList, "origin");

    const formatCount = (n: number): string => {
      if (n >= 1_000_000) return `${Math.floor(n / 1_000_000)}m`;
      if (n >= 1_000) return `${Math.floor(n / 1_000)}k`;
      return String(n);
    };

    const watermarkMonth = moment().format("MMM").toUpperCase();
    const watermarkYear = moment().format("DD");

    const updates = (this.state.latestNotes || [])
      .slice(0, 4)
      .map((item: any, index: number) => {
        if (!item || !item.note) {
          return {
            id: index,
            title: "No note available",
            meta: "Claim unavailable"
          };
        }

        const date = item?.createdOn
          ? moment(item.createdOn).format("DD/MM/YYYY")
          : "";

        return {
          id: item?.id || index,
          title: item?.note || "No note available",
          meta: `${date ? `${date} - ` : ""}${
            item?.claimNumber || "Unknown Claim"
          }`
        };
      });

    const fallbackUpdates = updates.length
      ? updates
      : [{ id: 0, title: "No recent notes", meta: "No claim notes found" }];

    const tickerItems: any[] = [];
    if (this.state.data && this.state.data.length > 0) {
      for (let i = 0; i < this.state.data.length; i++) {
        try {
          const date = moment(this.state.data[i][0]._audit.created.timestamp)
            .toDate()
            .toISOString();
          const createdDate = moment(date).utc().format("DD/MM/YYYY");
          tickerItems.push(
            <NewsTicker
              key={i}
              id={i + 1}
              title={`${this.state.data[i][0].news.news} By Admin `}
              meta={`${createdDate}`}
              url={""}
            />
          );
        } catch (e) {
          // skip malformed entries
        }
      }
    }

    const breakingNewsItems = tickerItems.length
      ? tickerItems
      : fallbackUpdates.map((update: any) => (
          <div
            className="breaking-news-fallback-v2"
            key={`breaking-${update.id}`}
          >
            <strong>{update.title}</strong>
            <span>{update.meta}</span>
          </div>
        ));

    if (loading) {
      return <LoadingPage />;
    }

    return (
      <div
        className={`dashboard-page-container-v2 ${
          isAdmin ? "admin-dashboard-v2" : ""
        }`}
      >
        <Helmet>
          <meta charSet="utf-8" />
          <title>AGE | Dashboard</title>
        </Helmet>

        <div
          className={`dashboard-v2-layout ${isAdmin ? "admin-layout-v2" : ""}`}
        >
          <section className="dashboard-main-v2">
            {isAdmin ? (
              <div className="admin-user-strip-v2">
                <div className="user-info">
                  Hi, {this.props.auth.displayName || this.props.auth.email}
                </div>
                <button
                  className="logout-button-v2"
                  onClick={this.logout}
                  title="Logout"
                  type="button"
                >
                  <Icon icon={power} size={18} />
                </button>
              </div>
            ) : null}

            <header className="dashboard-header-v2">
              <h1>{isAdmin ? "Group Growth" : "Local Monthly Report"}</h1>
              <div className="download-wrapper-v2">
                <span className="download-label-v2">
                  {downloadReportLoading ? (
                    <>
                      Downloading
                      <br />
                      report...
                    </>
                  ) : (
                    <>
                      Download full
                      <br />
                      report
                    </>
                  )}
                </span>
                <button
                  className="download-btn-v2"
                  type="button"
                  onClick={this.handleDownloadReport}
                  disabled={downloadReportLoading}
                  aria-busy={downloadReportLoading}
                  title={
                    downloadReportLoading
                      ? "Downloading report..."
                      : "Download full report"
                  }
                >
                  <Icon
                    icon={downloadReportLoading ? refreshCw : download}
                    size={24}
                  />
                </button>
              </div>
            </header>

            <div className="growth-card-v2">
              <div className="growth-grid-v2">
                <div className="metric-block-v2 metric-without-cancel-v2">
                  <div className="metric-icon-v2">
                    <Icon icon={checkSquare} size={22} />
                  </div>
                  <div className="metric-copy-v2">
                    <p className="metric-title-v2">
                      Total Claims without Cancelations
                    </p>
                    <h3>{formatCount(totalWithoutCancel)}</h3>
                  </div>
                </div>

                <div className="metric-block-v2 metric-completed-v2">
                  <div className="metric-icon-v2">
                    <Icon icon={settings} size={22} />
                  </div>
                  <div className="metric-copy-v2">
                    <p className="metric-title-v2">Completed Services</p>
                    <h3>{formatCount(completedCount)}</h3>
                  </div>
                </div>

                <div className="metric-block-v2 metric-cancelled-v2">
                  <div className="metric-icon-v2">
                    <Icon icon={xCircle} size={22} />
                  </div>
                  <div className="metric-copy-v2">
                    <p className="metric-title-v2">Total Cancelations</p>
                    <h3>{formatCount(cancelledCount)}</h3>
                  </div>
                </div>

                <div className="metric-block-v2 metric-total-v2">
                  <div className="metric-icon-v2">
                    <Icon icon={refreshCw} size={22} />
                  </div>
                  <div className="metric-copy-v2">
                    <p className="metric-title-v2">Total Claims</p>
                    <h3>{formatCount(totalClaims)}</h3>
                  </div>
                </div>

                <div className="metric-block-v2 metric-invoiced-v2">
                  <div className="metric-icon-v2 euro-icon-v2">
                    <span>€</span>
                  </div>
                  <div className="metric-copy-v2">
                    <p className="metric-title-v2">Invoiced <br/>
                      Services</p>
                    <h3>{formatCount(invoicedCount)}</h3>
                  </div>
                </div>
              </div>

              <div className="growth-divider-v2" />

              <div className="top-list-grid-v2">
                <div className="top-list-block-v2">
                  <div className="metric-icon-v2 small">
                    <img src={dashOutgoingIcon} alt="Claims Sent" />
                  </div>
                  <div>
                    <p className="metric-title-v2">Top 3 Claims Sent</p>
                    <ol>
                      {(topClaimsSent.length
                        ? topClaimsSent
                        : ["Copy", "Copy", "Copy"]
                      ).map((name, index) => (
                        <li key={`sent-${index}`}>{name}</li>
                      ))}
                    </ol>
                  </div>
                </div>

                <div className="top-list-block-v2">
                  <div className="metric-icon-v2 small">
                    <img src={dashIncomingIcon} alt="Claims Received" />
                  </div>
                  <div>
                    <p className="metric-title-v2">Top 3 Received</p>
                    <ol>
                      {(topClaimsReceived.length
                        ? topClaimsReceived
                        : ["Copy", "Copy", "Copy"]
                      ).map((name, index) => (
                        <li key={`received-${index}`}>{name}</li>
                      ))}
                    </ol>
                  </div>
                </div>
              </div>

              <div className="watermark-v2">
                <div>{watermarkMonth}</div>
                <div>{watermarkYear}</div>
              </div>
            </div>
          </section>

          {!isAdmin ? (
            <aside className="dashboard-aside-v2">
              <div className="user-container-v2">
                <div className="user-info">
                  Hi, {this.props.auth.displayName || this.props.auth.email}
                </div>
                <button
                  className="logout-button-v2"
                  onClick={this.logout}
                  title="Logout"
                  type="button"
                >
                  <Icon icon={power} size={18} />
                </button>
              </div>

              {/* <button type="button" className="new-claim-top-btn" onClick={() => this.props.history.push('/new-claim')}>
                <Icon icon={plus} size={24} />
                <span>New Claim</span>
              </button> */}

              <div className="search-control">
                <button
                  type="button"
                  className="search-icon-btn"
                  aria-label="Search claim or license plate"
                  onClick={this.handleDashboardSearch}
                >
                  <Icon icon={search} size={22} />
                </button>
                <input
                  className="search-input"
                  placeholder="Search claim or license plate"
                  value={this.state.searchValue}
                  onChange={this.handleSearchValueChange}
                  onKeyDown={this.handleSearchKeyDown}
                />
              </div>

              {this.state.searchError ? (
                <div className="search-feedback-v2">
                  {this.state.searchError}
                </div>
              ) : null}

              <h2 className="updates-title-v2">Last Updates</h2>

              <div className="updates-list-v2">
                {fallbackUpdates.map((update: any) => (
                  <div className="update-row-v2" key={`update-${update.id}`}>
                    <div className="update-icon-v2">
                      <Icon icon={mail} size={20} />
                    </div>
                    <div>
                      <div className="update-title-v2">{update.title}</div>
                      <div className="update-meta-v2">{update.meta}</div>
                    </div>
                  </div>
                ))}
              </div>

              {/* <button type="button" className="action-btn-v2 view-more-btn-v2">
                <Icon icon={eye} size={18} />
                <span>View More</span>
              </button> */}
              {/* <button
                type="button"
                className="action-btn-v2 view-more-btn-v2"
                onClick={() => this.props.history.push("/complaints")}
              >
                <Icon icon={eye} size={18} />
                <span>Complaints ({openComplaintsCount})</span>
              </button> */}
              <button
                type="button"
                className="action-btn-v2 contacts-btn-v2"
                onClick={() =>
                  this.setState({
                    infoPanelOpen: true,
                    infoPanelInitialTab: "2"
                  })
                }
              >
                <Icon icon={phone} size={18} />
                <span>Contacts</span>
              </button>
            </aside>
          ) : null}
        </div>
        <InfoPanel
          isOpen={this.state.infoPanelOpen}
          toggle={() => this.setState({ infoPanelOpen: false })}
          initialTab={this.state.infoPanelInitialTab}
        />
        <div className="breaking-news-bar-v2">
          <span className="breaking-news-badge-v2">Breaking News</span>
          <div className="breaking-news-ticker-v2">
            <Ticker isNewsTicker={true} slideSpeed={25}>
              {breakingNewsItems.map((item: any, index: number) => (
                <div key={index} className="news-item">
                  {item}
                </div>
              ))}
            </Ticker>
          </div>
        </div>
      </div>
    );
  }

  private renderLegacyLayout() {
    const {
      incomingClaims,
      outgoingClaims,
      completedClaims,
      partner,
      loading
    } = this.props;
    this.getNewsFeeds();
    const newss = [];
    const asd: {} | any = [];
    if (this.state !== null && this.state.data !== null) {
      for (let i = 0; i < this.state.data.length; i++) {
        const date = moment(this.state.data[i][0]._audit.created.timestamp)
          .toDate()
          .toISOString();
        const createdDate = moment(date).utc().format("DD/MM/YYYY");
        newss.push(
          <div>
            <img src={newsIcon} />
            {` */ ${createdDate}: ${this.state.data[i][0].news.title} - ${this.state.data[i][0].news.news} By ${this.state.data[i][0].origin} /*`}
          </div>
        );
        asd.push(
          <NewsTicker
            id={i + 1}
            title={`${this.state.data[i][0].news.news} By Admin `}
            meta={`${createdDate}`}
            url={""}
          />
        );
      }
    }

    if (loading) {
      return <LoadingPage />;
    }
    return (
      <div className="dashboard-page-container">
        <Helmet>
          <meta charSet="utf-8" />
          <title>AGE | Dashboard</title>
        </Helmet>
        <div className="user-container">
          Hi, {this.props.auth.displayName || this.props.auth.email}
          <Button className="logout-button" onClick={this.logout}>
            <Icon icon={power} />
          </Button>
        </div>

        <div className="dashboard-tile-container">
          <IncomingClaims claims={incomingClaims} partner={partner} />
          <OutgoingClaims claims={outgoingClaims} partner={partner} />
          <CompletedClaims claims={completedClaims} partner={partner} />
        </div>
        {newss.length !== 0 ? (
          <div id="breaking-news-container">
            <span className="breaking-news-title delay-animated slidein">
              BREAKING NEWS
            </span>
            <div className="newsticker">
              <Ticker isNewsTicker={true} slideSpeed={90}>
                {" "}
                {/* Adjust speed here */}
                {asd.map((newsItem: any, index: number) => (
                  <div key={index} className="news-item">
                    {newsItem}
                  </div>
                ))}
              </Ticker>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    if (DashboardPage.USE_NEW_V2_LAYOUT) {
      return this.renderNewLayout();
    }
    return this.renderLegacyLayout();
  }
}

const mapStateToProps = ({
  firestore: { data },
  firebase: { auth, profile }
}: {
  firestore: FirestoreReducer.Reducer;
  firebase: FirebaseReducer.Reducer;
}) => {
  const loading =
    !isLoaded(data.incomingClaims) ||
    !isLoaded(data.outgoingClaims) ||
    !isLoaded(data.completedClaims) ||
    !isLoaded(data.partner);
  const incomingClaims = data.incomingClaims;
  const outgoingClaims = data.outgoingClaims;
  const completedClaims = data.completedClaims;
  const complaints = data.complaints;
  const partner = data.partner;
  return {
    auth,
    loading,
    profile,
    partner,
    incomingClaims,
    outgoingClaims,
    completedClaims,
    complaints,
    firebase: getFirebase()
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  searchChange: (value: string) =>
    dispatch({
      type: "SEARCH_CHANGE",
      value
    })
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(DashboardPage);
